// NOTE - Tokens cannot be imported then used in StyleX.create() as is:
// "With the current architecture every file compilation can be cached. Only if a file changes do we need to re-compile it.
// "If we added support for imports, we would need to invalidate the cache of all dependent files whenever a file changed."
// from: https://github.com/facebook/stylex/issues/238#issuecomment-1869161263

import { defineConsts, defineVars } from '@stylexjs/stylex';
export const Primitives = {
  white50: "rgba(255, 255, 255, 0.05)",
  white100: "rgba(255, 255, 255, 0.1)",
  white200: "rgba(255, 255, 255, 0.2)",
  white300: "rgba(255, 255, 255, 0.3)",
  white400: "rgba(255, 255, 255, 0.4)",
  white500: "rgba(255, 255, 255, 0.5)",
  white600: "rgba(255, 255, 255, 0.6)",
  white700: "rgba(255, 255, 255, 0.7)",
  white800: "rgba(255, 255, 255, 0.8)",
  white900: "rgba(255, 255, 255, 0.9)",
  white950: "rgba(255, 255, 255, 0.95)",
  white: "rgba(255, 255, 255, 1)",
  neutral50: "#F8F8FB",
  neutral100: "#F3F3F7",
  neutral200: "#E7E7EE",
  neutral300: "#D7D7E0",
  neutral400: "#BDBDCA",
  neutral500: "#A2A1B0",
  neutral600: "#767589",
  neutral700: "#535165",
  neutral800: "#35334B",
  neutral900: "#25243A",
  neutral950: "#07061E",
  brand50: "#FDF2FB",
  brand100: "#FBE8F8",
  brand200: "#F9D1F2",
  brand300: "#F6ABE6",
  brand400: "#EF77D3",
  brand500: "#E54FBD",
  brand600: "#D42EA0",
  brand700: "#B71F83",
  brand800: "#A01E72",
  brand900: "#7F1C5C",
  brand950: "#4D0A35",
  positive50: "#EBFEF3",
  positive100: "#CEFDE0",
  positive200: "#A2F8C8",
  positive300: "#66EFAC",
  positive400: "#2ADD8B",
  positive500: "#05B469",
  positive600: "#009F5D",
  positive700: "#007F4E",
  positive800: "#00653E",
  positive900: "#015335",
  positive950: "#002F1E",
  destructive50: "#FDF2F7",
  destructive100: "#FCE7F1",
  destructive200: "#FAD0E3",
  destructive300: "#F8A9CC",
  destructive400: "#F274A8",
  destructive500: "#EA4A88",
  destructive600: "#D92964",
  destructive700: "#C81C51",
  destructive800: "#9B193F",
  destructive900: "#821938",
  destructive950: "#4F081C",
  important50: "#FFFBEB",
  important100: "#FFF5C6",
  important200: "#FFEC97",
  important300: "#FFD84A",
  important400: "#FFC520",
  important500: "#F9A307",
  important600: "#DD7B02",
  important900: "#7A360D",
  warning50: "#FFF5ED",
  warning100: "#FFE5CF",
  warning200: "#FECDAA",
  warning300: "#FDAB74",
  warning400: "#FB7C3C",
  warning500: "#F95916",
  warning600: "#EA3F0C",
  warning700: "#C22C0C",
  warning800: "#9A2512",
  warning900: "#7C2112",
  warning950: "#430D07",
  information50: "#F2F6FC",
  information100: "#E2EBF7",
  information200: "#CCDBF1",
  information300: "#A9C5E7",
  information400: "#80A6DA",
  information500: "#6288CF",
  information600: "#4F70C1",
  information700: "#455FB2",
  information800: "#3D4E90",
  information900: "#354473",
  information950: "#242B47"
};
export const ColorNeutral = {
  fillDefault: "var(--fillDefault-x1gcq4aj)",
  fillHover: "var(--fillHover-x9z0am9)",
  fillPressed: "var(--fillPressed-x1x6cjxs)",
  fillAccent: "var(--fillAccent-xlwa7cr)",
  fillAccentHover: "var(--fillAccentHover-x1jnpy9u)",
  fillFaded: "var(--fillFaded-xau15hv)",
  fillFadedHover: "var(--fillFadedHover-xczsmiq)",
  fillFadedPressed: "var(--fillFadedPressed-xsje7xg)",
  fillWeak: "var(--fillWeak-xzy5ezy)",
  fillWeakHover: "var(--fillWeakHover-x11z0dgb)",
  fillDisabled: "var(--fillDisabled-xajy8ca)",
  fillDisabledFaded: "var(--fillDisabledFaded-x1a28pd4)",
  borderDefault: "var(--borderDefault-xp1ofpb)",
  borderAccent: "var(--borderAccent-xdgtmnv)",
  borderHover: "var(--borderHover-x30sxoc)",
  borderPressed: "var(--borderPressed-xjdefg4)",
  borderFaded: "var(--borderFaded-x1dmkx7o)",
  borderWeak: "var(--borderWeak-x1aujgjg)",
  borderFadedPressed: "var(--borderFadedPressed-x18cwi6)",
  borderDisabled: "var(--borderDisabled-x1rxkxot)",
  borderFocus: "var(--borderFocus-x18dj6mn)",
  textDefault: "var(--textDefault-x74yqck)",
  textAccent: "var(--textAccent-xsfouhg)",
  textHover: "var(--textHover-xxkky2j)",
  textAccentHover: "var(--textAccentHover-xnhca8k)",
  textFaded: "var(--textFaded-xf8t41b)",
  textFadedHover: "var(--textFadedHover-x1b8lpek)",
  textPressed: "var(--textPressed-x797r7h)",
  textDisabled: "var(--textDisabled-x1jvtwo1)",
  iconDefault: "var(--iconDefault-x1qc2y0)",
  iconAccent: "var(--iconAccent-x5p17k4)",
  iconHover: "var(--iconHover-x7115nm)",
  iconAccentHover: "var(--iconAccentHover-xw78w91)",
  iconPressed: "var(--iconPressed-x10tow4i)",
  iconFaded: "var(--iconFaded-x1m0yoj2)",
  iconFadedHover: "var(--iconFadedHover-xg64ial)",
  iconWeak: "var(--iconWeak-xzspp4t)",
  iconWeakHover: "var(--iconWeakHover-xokt2nj)",
  iconDisabled: "var(--iconDisabled-x1aey1iv)",
  __varGroupHash__: "x1b7k1wu"
};
export const ColorNeutralInverse = {
  textDefault: "var(--textDefault-xzyo911)",
  textHover: "var(--textHover-xf6n2wn)",
  textAccent: "var(--textAccent-xn6y9cq)",
  textDisabled: "var(--textDisabled-xuniprj)",
  iconAccent: "var(--iconAccent-x1hrun0v)",
  __varGroupHash__: "xk3oxzx"
};
export const ColorBrand = {
  fillDefault: "var(--fillDefault-x15zpivn)",
  fillHover: "var(--fillHover-x1pz5dqh)",
  fillPressed: "var(--fillPressed-x2ihryi)",
  fillAccent: "var(--fillAccent-x2uixpb)",
  fillFaded: "var(--fillFaded-x14afast)",
  fillFadedHover: "var(--fillFadedHover-x1xwml9d)",
  fillWeak: "var(--fillWeak-xmvo1i4)",
  fillWeakHover: "var(--fillWeakHover-x1ngbyjy)",
  fillDisabled: "var(--fillDisabled-xf9l3kx)",
  fillDisabledFaded: "var(--fillDisabledFaded-x18hppxw)",
  borderDefault: "var(--borderDefault-x1nsdtrr)",
  borderHover: "var(--borderHover-xqgfo3s)",
  borderFaded: "var(--borderFaded-x1ygiviu)",
  borderFocus: "var(--borderFocus-xl65kz3)",
  borderDisabled: "var(--borderDisabled-xj6l1b0)",
  textDefault: "var(--textDefault-x1lrd5uf)",
  textAccent: "var(--textAccent-xcc8v1k)",
  textHover: "var(--textHover-x3timn8)",
  textDisabled: "var(--textDisabled-x1ru56u7)",
  textDisabledFaded: "var(--textDisabledFaded-x1uj7cuo)",
  iconDefault: "var(--iconDefault-x1qkakbz)",
  iconAccent: "var(--iconAccent-x17wt5di)",
  iconHover: "var(--iconHover-xgdj69e)",
  iconFaded: "var(--iconFaded-x2dxusp)",
  iconFadedHover: "var(--iconFadedHover-x21haac)",
  iconDisabled: "var(--iconDisabled-x5ktboq)",
  iconDisabledFaded: "var(--iconDisabledFaded-xmwk2os)",
  __varGroupHash__: "xepwnik"
};
export const ColorSuccess = {
  fillDefault: "var(--fillDefault-xyny7bk)",
  fillHover: "var(--fillHover-x49xem7)",
  fillPressed: "var(--fillPressed-x1hyrdx4)",
  fillAccent: "var(--fillAccent-x1c57u00)",
  fillFaded: "var(--fillFaded-x1eww29w)",
  fillFadedHover: "var(--fillFadedHover-x1iaio8x)",
  fillWeak: "var(--fillWeak-xur5zm3)",
  fillWeakHover: "var(--fillWeakHover-xoprryd)",
  fillDisabled: "var(--fillDisabled-x1i3mllu)",
  fillDisabledFaded: "var(--fillDisabledFaded-x1kkgm9a)",
  borderDefault: "var(--borderDefault-xpfpnob)",
  borderHover: "var(--borderHover-x1boklff)",
  borderPressed: "var(--borderPressed-xi6mhz5)",
  borderAccent: "var(--borderAccent-xpoq9ce)",
  borderFaded: "var(--borderFaded-xgr59bm)",
  borderFadedHover: "var(--borderFadedHover-x6lpk47)",
  borderDisabled: "var(--borderDisabled-x14trpze)",
  borderFocus: "var(--borderFocus-xjfse9y)",
  textDefault: "var(--textDefault-xgn9v8e)",
  textHover: "var(--textHover-x1ew076p)",
  textAccent: "var(--textAccent-x1bj9gxa)",
  textDisabled: "var(--textDisabled-xctz7d8)",
  textDisabledFaded: "var(--textDisabledFaded-x1iqvvyt)",
  iconDefault: "var(--iconDefault-x18ih0lr)",
  iconHover: "var(--iconHover-x6pt4bf)",
  iconAccent: "var(--iconAccent-x67sck7)",
  iconDisabled: "var(--iconDisabled-x1tcedqt)",
  iconDisabledFaded: "var(--iconDisabledFaded-xf0vbry)",
  __varGroupHash__: "xhrhsye"
};
export const ColorDanger = {
  fillDefault: "var(--fillDefault-xnl6i8)",
  fillHover: "var(--fillHover-x9g1gn)",
  fillPressed: "var(--fillPressed-x1fnc873)",
  fillAccent: "var(--fillAccent-x19dsd4f)",
  fillFaded: "var(--fillFaded-x12b7i3m)",
  fillFadedHover: "var(--fillFadedHover-x18rqus9)",
  fillWeak: "var(--fillWeak-xlygd9q)",
  fillWeakHover: "var(--fillWeakHover-xlp1mnz)",
  fillDisabled: "var(--fillDisabled-xoathgp)",
  fillDisabledFaded: "var(--fillDisabledFaded-x1fvjal4)",
  borderDefault: "var(--borderDefault-x1rfquwg)",
  borderHover: "var(--borderHover-xvspp5j)",
  borderPressed: "var(--borderPressed-x11t47tm)",
  borderAccent: "var(--borderAccent-x1bixy9h)",
  borderFaded: "var(--borderFaded-x1aggt67)",
  borderFadedHover: "var(--borderFadedHover-xddd59l)",
  borderDisabled: "var(--borderDisabled-xnhkut8)",
  borderFocus: "var(--borderFocus-xj0czxx)",
  textDefault: "var(--textDefault-xmo5eo4)",
  textHover: "var(--textHover-xpgrbfj)",
  textAccent: "var(--textAccent-xb1a10y)",
  textDisabled: "var(--textDisabled-x1lvw04s)",
  textDisabledFaded: "var(--textDisabledFaded-xpy9k8l)",
  iconDefault: "var(--iconDefault-xawgfxj)",
  iconHover: "var(--iconHover-xyxom47)",
  iconAccent: "var(--iconAccent-x1fa7dn5)",
  iconDisabled: "var(--iconDisabled-xg14hqc)",
  iconDisabledFaded: "var(--iconDisabledFaded-xnwz23l)",
  __varGroupHash__: "x18ohecp"
};
export const ColorImportant = {
  fillWeak: "var(--fillWeak-x40vrmv)",
  fillWeakHover: "var(--fillWeakHover-x12b6jr5)",
  fillFaded: "var(--fillFaded-x1m91t4o)",
  fillFadedHover: "var(--fillFadedHover-x13p5eic)",
  fillPressed: "var(--fillPressed-x1ro36o9)",
  fillDefault: "var(--fillDefault-x6e9y23)",
  fillHover: "var(--fillHover-x1dsywsq)",
  fillAccent: "var(--fillAccent-x1pjrxk5)",
  fillDisabled: "var(--fillDisabled-x1yug1o2)",
  borderDefault: "var(--borderDefault-x1tdxmen)",
  borderHover: "var(--borderHover-xcy4u2u)",
  borderPressed: "var(--borderPressed-x93ubty)",
  borderAccent: "var(--borderAccent-xplcq7p)",
  borderFaded: "var(--borderFaded-x1hjm79w)",
  borderFadedHover: "var(--borderFadedHover-xri33lv)",
  borderDisabled: "var(--borderDisabled-x4m0p9l)",
  borderFocus: "var(--borderFocus-x1h9yh5a)",
  textDefault: "var(--textDefault-x126zv27)",
  textAccent: "var(--textAccent-x1tphwoa)",
  textHover: "var(--textHover-x1hdj09w)",
  textDisabled: "var(--textDisabled-x1e9nguw)",
  iconDefault: "var(--iconDefault-xaeiq2c)",
  iconAccent: "var(--iconAccent-x1rstdnc)",
  iconHover: "var(--iconHover-x5lu4kb)",
  iconDisabled: "var(--iconDisabled-x1lpn3ln)",
  __varGroupHash__: "xfjk4l2"
};
export const ColorWarning = {
  fillDefault: "var(--fillDefault-x17p64w4)",
  fillHover: "var(--fillHover-xn6z6xl)",
  fillPressed: "var(--fillPressed-xzdqki)",
  fillAccent: "var(--fillAccent-xhp6p1t)",
  fillFaded: "var(--fillFaded-xr6xu5x)",
  fillFadedHover: "var(--fillFadedHover-xbod1l8)",
  fillWeak: "var(--fillWeak-xdqd04o)",
  fillWeakHover: "var(--fillWeakHover-x52gx16)",
  fillDisabled: "var(--fillDisabled-x17yyqmh)",
  fillDisabledFaded: "var(--fillDisabledFaded-x3fvptj)",
  borderDefault: "var(--borderDefault-x1jihapa)",
  borderHover: "var(--borderHover-x1l7u6e3)",
  borderPressed: "var(--borderPressed-x105tdf8)",
  borderAccent: "var(--borderAccent-xn9p9sc)",
  borderFaded: "var(--borderFaded-x1mcl2tp)",
  borderFadedHover: "var(--borderFadedHover-x18ath29)",
  borderDisabled: "var(--borderDisabled-xzntau1)",
  borderFocus: "var(--borderFocus-x3faet)",
  textDefault: "var(--textDefault-x1g8pg7s)",
  textHover: "var(--textHover-x574id2)",
  textAccent: "var(--textAccent-xjdx5oi)",
  textDisabled: "var(--textDisabled-xa9hji6)",
  textDisabledFaded: "var(--textDisabledFaded-x4y108y)",
  iconDefault: "var(--iconDefault-xcv4vxy)",
  iconHover: "var(--iconHover-xc3zy2v)",
  iconAccent: "var(--iconAccent-x1n6ymgj)",
  iconDisabled: "var(--iconDisabled-x1kghebi)",
  iconDisabledFaded: "var(--iconDisabledFaded-x840hfg)",
  __varGroupHash__: "x1k1glz2"
};
export const ColorInformation = {
  fillDefault: "var(--fillDefault-x1dow3io)",
  fillHover: "var(--fillHover-xfzhk1e)",
  fillPressed: "var(--fillPressed-xtj013a)",
  fillAccent: "var(--fillAccent-xew8kza)",
  fillFaded: "var(--fillFaded-x116s9ab)",
  fillFadedHover: "var(--fillFadedHover-xdaprbn)",
  fillWeak: "var(--fillWeak-x1h5simn)",
  fillWeakHover: "var(--fillWeakHover-x1m5f58n)",
  fillDisabled: "var(--fillDisabled-xq4titn)",
  borderDefault: "var(--borderDefault-x3q8mfc)",
  borderHover: "var(--borderHover-x1dutqdg)",
  borderFaded: "var(--borderFaded-x1gdzhib)",
  borderDisabled: "var(--borderDisabled-xjfj9q1)",
  borderFocus: "var(--borderFocus-x3o91y7)",
  textDefault: "var(--textDefault-x2w7lh5)",
  textHover: "var(--textHover-x1igfjnk)",
  textAccent: "var(--textAccent-x1p0k6t0)",
  textDisabled: "var(--textDisabled-x16339f8)",
  iconDefault: "var(--iconDefault-xwfw9ee)",
  iconHover: "var(--iconHover-x1fvmwpv)",
  iconDisabled: "var(--iconDisabled-x1pphqhz)",
  __varGroupHash__: "xc0kptx"
};